"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFinPackageItemSchema = exports.finPackageInclusionTypeEnum = exports.updateFinPackageSchema = exports.createFinPackageSchema = exports.finPackageShape = void 0;
const zod_1 = require("zod");
/**
 * Enterprise Architecture Handbook v1.0 (IP Billing Administration,
 * Module 4 — Package Configuration). Manages only the `FinPackage`
 * header as a DRAFT plus its `FinPackageItem` inclusion/exclusion
 * rows — the existing, frozen `POST /financial/packages/:packageId/activate`
 * (`PackageApplicationService`, Stage 5C.3) owns the DRAFT→ACTIVE
 * transition (and its own "must have at least one INCLUDED item"
 * check); this schema deliberately excludes `status`/`versionNumber`
 * so this new CRUD cannot bypass that lifecycle.
 */
exports.finPackageShape = {
    packageCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    categoryId: zod_1.z.string().uuid().optional(),
    basePrice: zod_1.z.number().int().positive(),
    validityDays: zod_1.z.number().int().positive().optional(),
    maxUsageCount: zod_1.z.number().int().positive().optional(),
    branchId: zod_1.z.string().uuid().optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.createFinPackageSchema = zod_1.z.object(exports.finPackageShape);
exports.updateFinPackageSchema = zod_1.z.object(exports.finPackageShape).partial();
exports.finPackageInclusionTypeEnum = zod_1.z.enum(['INCLUDED', 'EXCLUDED']);
exports.createFinPackageItemSchema = zod_1.z.object({
    packageId: zod_1.z.string().uuid(),
    chargeId: zod_1.z.string().uuid(),
    inclusionType: exports.finPackageInclusionTypeEnum,
    quantityLimit: zod_1.z.number().int().positive().optional(),
});
//# sourceMappingURL=fin-package.schema.js.map